var AddressGiftListView = (function (_baseView, _fieldView, _getPageTemplate) {

    var GiftAddress = _baseView.extend({
        events: {
            'click': 'select'
        },

        initialize: function (opts) {
            this.listenTo(this.model, 'change', _.bind(this.render, this));
            this.listenTo(this.model, 'remove', _.bind(this.remove, this));
            this.render();
        },

        select: function () {
            window.app && app.event && app.event.useAnotherAddress();
            this._inProgress(true);
            this.model.select().done(_.bind(this._selected, this));
        },

        _selected: function () {
            this._inProgress(false);
            this.display('checkout');
        },

        render: function () {
            var address = this.model.toJSON();
            if (address.AdditionalData) {
                var additionalData = JSON.parse(address.AdditionalData);
                address.GiftMessage = additionalData.GiftMessage;
            }
            this.$el = $.tmpl('bt-checkout-delivery-address', address);
        },
        _inProgress: function(isActive) {
            this.$el.toggleClass('processing-animation', !!isActive);
        }

    });

    return _baseView.extend({
        el: '@giftAddressesList',

        events: {
            'click @addNewGiftAddress': '_addGiftAddress'
        },

        displayRoutes: ['checkout.address.gift.list'],

        initialize: function () {
            _.bindAll(this, '_renderAddress', '_addGiftAddress');
           this.collection.on('add', this._renderAddress);
        },

        _addGiftAddress: function () {
            this.display('checkout.address.gift.form');
        },

        _renderAddress: function(m) {
            var view = new GiftAddress({ model: m });
            this.$('@list').append(view.$el);
        },

        beforeShow: function() {
            this.collection.fetch().fail(_.bind(function () {
                this._displayRouter.removeLatest();
                this.display('checkout.address.gift.form');
            }, this));
        }
    });
})(BaseView, FieldView, kos.getPageTemplate, GlobalSettings);